import React from 'react';
import { GenericFilterProps, RangeTuple } from '../types';
import { Section, SectionBody, SectionTitle } from '../styled/common';
import Range from 'ds/components/input/RangeField/RangeField';
import { useLocale } from 'locale';
import { parseRangeValues, prepareRangeValues } from '../utils';
import { MarketplaceType } from 'utils/entities';
import { useScreenBreakpoint } from 'consts/breakpoints';


const VISIBLE_ITEMS_COUNT = 5;

const Employees: React.FC<GenericFilterProps <'numberOfEmployeesRange'>> = ({
  type,
  config,
  marketplace,
  intermediateValue,
  setIntermediateValue,
}) => {
  const { t } = useLocale();
  const onChange = ([ from, to ]: RangeTuple<number>) => {
    setIntermediateValue([ parseRangeValues(from), parseRangeValues(to) ]);
  };
  const { employeesOptions } = config;
  const isCommercial = marketplace === MarketplaceType.Commercial;
  const options = employeesOptions.map((v) => ({
    value: v,
    label: t('filters.employeesLabels', { employees: v }) || `${v}`,
  }));

  const isCombinedFiltersSearchView = useScreenBreakpoint() < 3;

  return (
    <Section
      data-section-filter-name={type}
      data-auto-filter-name={type}
      data-auto={`filter-${type}`}
      combinedFiltersSearchMode={isCombinedFiltersSearchView}
    >
      <SectionTitle combinedFiltersSearchMode={isCombinedFiltersSearchView} isBold>
        {t('filters.employees', { isCommercial })}
      </SectionTitle>
      <SectionBody combinedFiltersSearchMode={isCombinedFiltersSearchView}>
        <Range
          expandOptionsPosition="top"
          onChange={onChange}
          values={prepareRangeValues(intermediateValue)}
          options={options}
          readOnly
          fullWidth
          visibleItemsCount={VISIBLE_ITEMS_COUNT}
          mode={isCombinedFiltersSearchView ? 'black' : 'default'}
          labelFrom={isCombinedFiltersSearchView ? t('filters.employees.from') : undefined}
          labelTo={isCombinedFiltersSearchView ? t('filters.employees.to') : undefined}
        />
      </SectionBody>
    </Section>
  );
};

export default Employees;
